import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import API from "../../api/api";
import { useEffect, useState } from "react";

export default function GuideCalendar() {

  const [events, setEvents] = useState([]);


  useEffect(() => {
    load();
  }, []);



  const load = async () => {

    try {

      const [
  toursRes,
  availabilityRes,
  googleRes
] = await Promise.all([

  API.get("/guide/calendar/tours"),

  API.get("/guide/availability"),

  API.get("/guide/google/events")
    .catch(() => ({ data: [] }))

]);



      /*
      ==========================
      ASSIGNED TOURS
      ==========================
      */

      const tourEvents =
        toursRes.data.map(tour => ({

          id:`tour-${tour.id}`,

          title:
            `${tour.title} • 👥 ${tour.capacity}`,

          start:
            tour.start_datetime,

          end:
            tour.end_datetime,


          backgroundColor:"#0ea5e9",

          borderColor:"#0284c7",

          textColor:"#ffffff",

          className:"tour-event"

        }));





      /*
      ==========================
      GUIDE AVAILABILITY
      ==========================
      */


      const availabilityEvents =
        availabilityRes.data.map(a => ({

          id:`availability-${a.id}`,

          title:
            a.title || "Available",

          start:
            a.start_datetime,

          end:
            a.end_datetime,


          backgroundColor:"#22c55e",

          borderColor:"#16a34a",

          textColor:"#ffffff",

          className:"availability-event"

        }));






      /*
      ==========================
      GOOGLE CALENDAR
      ==========================
      */


      const googleEvents =
        googleRes.data.map(event => ({

          id:
            `google-${event.id}`,

          title:
            `📅 ${event.summary || "Google Event"}`,

          start:
            event.start.dateTime ||
            event.start.date,


          end:
            event.end?.dateTime ||
            event.end?.date,


          backgroundColor:"#8b5cf6",

          borderColor:"#7c3aed",

          textColor:"#ffffff",

          className:"google-event"

        }));





      setEvents([

        ...tourEvents,

        ...availabilityEvents,

        ...googleEvents

      ]);



    } catch(err) {


      console.error(
        "CALENDAR LOAD ERROR:",
        err.response?.data || err
      );


    }

  };





  const connectGoogle = async()=>{

    try{

      const res =
        await API.get(
          "/guide/google/connect"
        );


      window.location.href =
        res.data.url;


    }catch(err){

      console.error(err);

    }

  };





  return (

    <div style={page}>


      <div style={header}>

        <h2 style={title}>
          My Schedule
        </h2>


        <p style={subtext}>
          Your assigned tours, availability and Google Calendar events
        </p>

      </div>




      <div style={legend}>


        <div style={legendItem}>
          <span
            style={{
              ...dot,
              background:"#0ea5e9"
            }}
          />

          Assigned Tours

        </div>



        <div style={legendItem}>
          <span
            style={{
              ...dot,
              background:"#22c55e"
            }}
          />

          Availability

        </div>



        <div style={legendItem}>
          <span
            style={{
              ...dot,
              background:"#8b5cf6"
            }}
          />

          Google Calendar

        </div>


      </div>





      <button
        onClick={connectGoogle}
        style={googleButton}
      >

        Connect Google Calendar

      </button>






      <div style={calendarBox}>


        <FullCalendar


          plugins={[
            dayGridPlugin,
            timeGridPlugin
          ]}


          initialView="dayGridMonth"


          height="auto"


          events={events}



          headerToolbar={{

            left:
              "prev,next today",

            center:
              "title",

            right:
              "dayGridMonth,timeGridWeek,timeGridDay"

          }}



          slotMinTime="08:00:00"


          slotMaxTime="22:00:00"



          eventDisplay="block"


          dayMaxEventRows={3}


          nowIndicator={true}


        />


      </div>





      <style>{`

        .tour-event,
        .availability-event,
        .google-event {

          border-radius:10px !important;

          padding:3px 6px !important;

          font-size:12px !important;

          font-weight:500 !important;

          border:none !important;

          box-shadow:
          0 4px 10px rgba(0,0,0,0.08);

        }



        .fc-toolbar-title {

          font-size:18px !important;

          font-weight:600;

          color:#0f172a;

        }



        .fc-button {

          background:#f1f5f9 !important;

          border:
          1px solid #e2e8f0 !important;

          color:#0f172a !important;

          text-transform:capitalize !important;

          box-shadow:none !important;

        }



        .fc-button:hover {

          background:#e2e8f0 !important;

        }



        .fc-button-primary:not(:disabled).fc-button-active {

          background:#0ea5e9 !important;

          color:white !important;

        }



        .fc-daygrid-day-number {

          color:#0f172a;

          font-weight:500;

        }


      `}</style>



    </div>

  );

}






/* ================= STYLES ================= */


const page = {

  padding:24,

  background:"#f8fafc",

  minHeight:"100vh"

};



const header = {

  marginBottom:16

};



const title = {

  margin:0,

  fontSize:22,

  fontWeight:600,

  color:"#0f172a"

};



const subtext = {

  marginTop:6,

  fontSize:13,

  color:"#64748b"

};



const legend = {

  display:"flex",

  gap:16,

  marginBottom:12,

  alignItems:"center"

};



const legendItem = {

  display:"flex",

  alignItems:"center",

  gap:6,

  fontSize:13,

  color:"#334155"

};



const dot = {

  width:10,

  height:10,

  borderRadius:"50%"

};



const googleButton = {

  marginBottom:15,

  background:"#8b5cf6",

  color:"white",

  border:"none",

  padding:"10px 16px",

  borderRadius:8,

  cursor:"pointer",

  fontWeight:500

};



const calendarBox = {

  background:"white",

  padding:18,

  borderRadius:14,

  border:"1px solid #e2e8f0",

  boxShadow:
    "0 6px 20px rgba(15,23,42,0.05)"

};